class HircanGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.HircanGallery__Track');
    this.slides = [...this.querySelectorAll('[data-image-id]')];
    this.thumbs = [...this.querySelectorAll('[data-hircan-image]')];
    this.stage = this.querySelector('.HircanGallery__Stage');
    this.pointerFine = matchMedia('(hover: hover) and (pointer: fine)');
    this.cursor = document.createElement('span');
    this.cursor.className = 'HircanGallery__Cursor';
    this.cursor.setAttribute('aria-hidden', 'true');
    this.cursor.innerHTML = '<svg viewBox="0 0 16 16" fill="none"><path d="m6 4 4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    if (this.slides.length > 1) this.stage.append(this.cursor);
    this.abort = new AbortController();
    const options = {signal: this.abort.signal};
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-hircan-image]');
      if (button) this.show(button.dataset.hircanImage);
      const arrow = event.target.closest('[data-gallery-direction]');
      if (arrow) this.advance(Number(arrow.dataset.galleryDirection));
    }, options);
    this.stage.addEventListener('pointermove', event => {
      if (!this.pointerFine.matches || event.pointerType !== 'mouse' || this.slides.length < 2) return;
      const bounds = this.stage.getBoundingClientRect();
      const x = event.clientX - bounds.left;
      this.cursor.style.left = x + 'px';
      this.cursor.style.top = (event.clientY - bounds.top) + 'px';
      this.cursor.dataset.direction = x < bounds.width / 2 ? '-1' : '1';
      this.stage.classList.add('is-pointer-active');
    }, {...options, passive: true});
    this.stage.addEventListener('pointerleave', () => this.stage.classList.remove('is-pointer-active'), options);
    this.stage.addEventListener('blur', () => this.stage.classList.remove('is-pointer-active'), options);
    this.stage.addEventListener('click', event => {
      if (!this.pointerFine.matches || event.pointerType === 'touch' || !this.stage.classList.contains('is-pointer-active') || event.target.closest('button')) return;
      const bounds = this.stage.getBoundingClientRect();
      this.advance(event.clientX - bounds.left < bounds.width / 2 ? -1 : 1);
    }, options);
    this.querySelector('.HircanGallery__Stage').addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      const next = this.slides[Math.max(0,Math.min(this.slides.length - 1,index + (event.key === 'ArrowRight' ? 1 : -1)))];
      this.show(next.dataset.imageId);
    }, options);
    this.track.addEventListener('scroll', () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        const slide = this.slides[Math.round(this.track.scrollLeft / this.track.clientWidth)];
        if (slide) this.select(slide.dataset.imageId);
      });
    }, {...options,passive:true});
    document.addEventListener('variant:changed', event => {
      const variant = event.detail.variant;
      if (variant && variant.featured_image) this.show(String(variant.featured_image.id));
    }, options);
    const selected = this.thumbs.find(button => button.getAttribute('aria-current') === 'true');
    if (selected) requestAnimationFrame(() => this.show(selected.dataset.hircanImage, 'instant'));
  }
  disconnectedCallback() { this.abort?.abort(); cancelAnimationFrame(this.frame); }
  advance(direction) {
    if (this.slides.length < 2 || !this.track.clientWidth) return;
    const selected = this.thumbs.findIndex(button => button.getAttribute('aria-current') === 'true');
    const current = selected >= 0 ? selected : Math.round(this.track.scrollLeft / this.track.clientWidth);
    const next = (current + direction + this.slides.length) % this.slides.length;
    this.show(this.slides[next].dataset.imageId);
  }
  show(id, behavior) {
    const index = this.slides.findIndex(slide => slide.dataset.imageId === String(id));
    if (index < 0) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    this.track.scrollTo({left:index * this.track.clientWidth,behavior:behavior || motion});
    this.select(String(id));
  }
  select(id) { this.thumbs.forEach(button => button.setAttribute('aria-current', String(button.dataset.hircanImage === id))); }
}
if (!customElements.get('hircan-gallery')) customElements.define('hircan-gallery',HircanGallery);
document.addEventListener('variant:changed',event => {
  const scope = event.target.closest?.('[data-section-type]') || document;
  const amount = scope.querySelector('.HircanInstallments');
  const prices = scope.querySelector('[data-hircan-pix-label]');
  const variant = event.detail.variant;
  if (prices && variant) {
    const primary = prices.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
    if (primary) {
      primary.textContent = new Intl.NumberFormat('pt-BR', {style:'currency', currency:'BRL'}).format(Math.round(variant.price * 95 / 100) / 100) + ' ';
      const label = document.createElement('span'); label.className = 'HircanPixLabel'; label.textContent = prices.dataset.hircanPixLabel; primary.append(label);
    }
  }
  if (amount) amount.hidden = !variant;
  const pixNote = scope.querySelector('.HircanPixNote');
  if (pixNote) pixNote.hidden = !variant;
  if (amount && event.detail.variant) amount.textContent = amount.dataset.format.replace('__amount__',new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(Math.floor(event.detail.variant.price / 3) / 100));
});


let hircanExperiencePending = false;
document.addEventListener('click', async event => {
  const button = event.target.closest('[data-hircan-add-experience]');
  if (!button || hircanExperiencePending) return;
  hircanExperiencePending = true;
  const label = button.textContent;
  const status = button.parentElement.querySelector('.HircanCartStatus');
  button.disabled = true; button.textContent = button.dataset.busy;
  if (status) status.textContent = '';
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || button.dataset.error);
    if (status) status.textContent = button.dataset.success;
    if (document.querySelector('#sidebar-cart')) document.dispatchEvent(new CustomEvent('product:added',{bubbles:true,detail:{quantity:1,variant:result.items?.[0]}}));
    else window.location.assign(root + 'cart');
  } catch(error) { if (status) status.textContent = error.message || button.dataset.error; }
  finally { hircanExperiencePending = false; button.disabled = false; button.textContent = label; }
});
